module.exports = __webpack_public_path__ + "assets/img/accept.f92ca7b2.svg";